"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    // switcher
    (0, _jquery2.default)(".switch-toggle", this).each(function () {
        var checkbox = (0, _jquery2.default)(this).find("input[type=checkbox]");
        setSwitchToggle(checkbox);
        checkbox.on('change', function () {
            setSwitchToggle(this);
        });
    });
};

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setSwitchToggle(element) {
    var $el = (0, _jquery2.default)(element);
    var $wrapper = $el.closest("[data-switcher-wrapper='true']");
    var $parent = $el.closest('.switcher');
    var checked = $el.is(':checked');

    $parent.toggleClass('checked', checked);
    $wrapper.find("[data-switcher-value='true']").toggleClass('hide', !checked);
    $wrapper.find("[data-switcher-value='false']").toggleClass('hide', checked);
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/switcher.js
// module id = 1134
// module chunks = 1